export default {
	JPG: {
		text: '.jpg',
		value: 'image/jpeg',
		extensao: 'JPG',
	},
	JPEG: {
		text: '.jpeg',
		value: 'image/jpeg',
		extensao: 'JPEG',
	},
	PNG: {
		text: '.png',
		value: 'image/png',
		extensao: 'PNG',
	},
	PDF: {
		text: '.pdf',
		value: 'application/pdf',
		extensao: 'PDF',
	},
	DOC: {
		text: '.doc',
		value: 'application/msword',
		extensao: 'DOC',
	},
	DOCX: {
		text: '.docx',
		value: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
		extensao: 'DOCX',
	},
	XLS: {
		text: '.xls',
		value: 'application/vnd.ms-excel',
		extensao: 'XLS',
	},
	XLSX: {
		text: '.xlsx',
		value: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
		extensao: 'XLSX',
	},
	CSV: {
		text: '.csv',
		value: 'text/csv',
		extensao: 'CSV',
	},
}
